import { IFamocoTranslations } from '..';

const famoco: IFamocoTranslations = {
  famoco_settings: 'Configuración Famoco',
  api_token: 'API Token',
  api_token_placeholder: 'Introduzca el API token de la interfaz Famoco',
  has_api_token: 'API token',
  token_not_set: 'No configurado',
  token_is_set: 'Configurado',
  org_id: 'ID de organización',
  org_id_placeholder: 'Introduzca el ID de organización (ej: 1487)',
  base_url: 'URL base',
  base_url_placeholder: 'https://my.famoco.com',
  save_config: 'Guardar configuración',
  sync_fleets: 'Sincronizar flotas',
  fleets: 'Flotas',
  fleet_name: 'Nombre de flota',
  famoco_id: 'Famoco ID',
  not_configured: 'Famoco no está configurado. Introduzca las credenciales de la API para comenzar.',
  no_fleets: 'No hay flotas sincronizadas. Haga clic en "Sincronizar flotas" tras guardar la configuración.',
  config_saved: 'Configuración guardada.',
  fleets_synced: 'Flotas sincronizadas correctamente.',
  config_error: 'Error al guardar la configuración.',
  sync_error: 'Error al sincronizar las flotas.',
  updated_at: 'Última actualización',
  sync_devices: 'Sincronizar dispositivos',
  sync_devices_error: 'Error al sincronizar los dispositivos.',
  famoco_devices: 'Dispositivos Famoco',
  in_fleet: 'En flota',
  in_stock: 'En stock',
  licenses: 'Licencias',
  api_token_placeholder_update: 'Introduzca un nuevo token para reemplazar el existente',
  validate_token: 'Validar token',
  validating: 'Validando…',
  token_valid: 'Token válido',
  validation_error: 'La validación del token falló.',
  select_org: 'Seleccionar organización',
  org: 'Organización',
  save_and_sync: 'Guardar y sincronizar',
  saving_and_syncing: 'Guardando y sincronizando…',
  save_and_sync_success: 'Configuración guardada y sincronizada.',
  sync_all: 'Sincronizar estado Famoco',
  sync_all_success: 'Estado Famoco sincronizado.',
  sync_all_error: 'Sincronización fallida.',
  update_token: 'Actualizar token',
  cancel: 'Cancelar'
};

export default famoco;
